import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { faqs } from "../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-brand-50 px-5 py-16 md:px-8 md:py-24" data-id="element-111" data-mp="1cf041c63r6ni">
      <div className="mx-auto max-w-3xl" data-id="element-112" data-mp="1ccnd49id9lyb">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-113" data-mp="2a2idkp7l8csk">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-brand-200 rounded-3xl bg-white px-5 md:px-8" data-id="element-114" data-mp="251b5sq5g3dlw">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-115" data-mp="1v72cw1ci5in7" data-mpi={i}>
                <h3 data-id="element-116" data-mp="oonrfnzwwlql">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-bold text-ink focus:outline-none focus-visible:text-brand-700 md:text-lg" data-id="element-117" data-mp="opys3ey29ddh">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-118" data-mp="1aqc1vhb4ur9l" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-119" data-mp="16oh4gnwboy13">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-120" data-mp="rz2pn09z9oeb">
                      <p className="pb-5 text-base leading-relaxed text-muted" data-id="element-121" data-mp="mz6nz7or691x">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCTA label="I'm ready — give me instant access" data-id="element-122" data-mp="2fwtror4s98ts" />
      </div>
    </section>;
}